import restApi from '@axios';

export default {
    saveQuestion({ commit }, data) {
        return new Promise(function (resolve, reject) {
            restApi.post('/ext/avd-formulario-resposta/save-question', data).then(response => {
                if (response.data) {
                    resolve(response.data.data)
                }

                reject('NAO_AUTORIZADO')
            }).catch(error => reject(error))
        })
    }
}